import { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../../context";
import Logo from "../../components/logo";
import LanguageSwitcher from "../../components/languageSwitcher";
import ThemeToggle from "../../components/themeToggle";
import { Link } from "react-router-dom";

export default function ContributionNavbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isDarkMode } = useAppContext();
  const { t } = useTranslation();
  const menuRef = useRef(null);

  const navLinks = [{ href: "/help-center", label: "Help Center", id: "" }];

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  return (
    <nav className="fixed top-0 left-0 right-0 px-6 py-4 flex items-center justify-between bg-[rgb(0,73,69)] backdrop-blur-sm z-50">
      <div className="flex items-center">
        <Logo />
      </div>

      {/* Desktop Navigation */}
      <div className="hidden md:flex items-center space-x-12 text-white">
        <Link to={"/"} className={`font-medium hover:text-yellow-400 `}>
          {t(`links.Home`)}
        </Link>
        {navLinks.map((link) => (
          <Link
            key={link.id}
            to={link.href}
            className={`font-medium hover:text-yellow-400`}
          >
            {t(`links.${link.label}`)}
          </Link>
        ))}
      </div>

      {/* Mobile Navigation Toggle */}
      <div className="md:hidden flex items-center space-x-4">
        <button
          className="text-white focus:outline-none"
          onClick={toggleMenu}
          aria-controls="mobile-menu"
          aria-expanded={isMenuOpen}
          aria-label={isMenuOpen ? t("links.closeMenu") : t("links.openMenu")}
        >
          {isMenuOpen ? (
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          ) : (
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              />
            </svg>
          )}
        </button>
      </div>

      <div
        ref={menuRef}
        id="mobile-menu"
        className={`md:hidden absolute top-16 left-0 w-full h-screen bg-[rgb(0,73,69)] text-white flex flex-col items-start py-4 space-y-4 z-50 transition-transform duration-300 px-6 ${
          isMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <Link to={"/"} className={`font-medium hover:text-yellow-400 `}>
          {t(`links.Home`)}
        </Link>
        {navLinks.map((link) => (
          <Link
            key={link.id}
            to={link.href}
            className={`font-medium hover:text-yellow-400`}
          >
            {t(`links.${link.label}`)}
          </Link>
        ))}

        <div className="flex flex-col items-start space-y-4 mt-4">
          <LanguageSwitcher onChangeLanguage={() => setIsMenuOpen(false)} />
          <div className="flex items-center space-x-2">
            <ThemeToggle
              isNewDesign={true}
              onToggleTheme={() => setIsMenuOpen(false)}
            />
            <span className="font-medium">
              {isDarkMode ? t("themes.darkMode") : t("themes.lightMode")}
            </span>
          </div>
        </div>
      </div>

      <div className="hidden md:flex items-center space-x-4">
        <LanguageSwitcher />
        <ThemeToggle isNewDesign={true} />
      </div>
    </nav>
  );
}
